import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import NavBar from "./NavBar";
import Footer from "./Footer";
import { Toolbar } from "@mui/material";

const Layout = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  return (
    <>
      <div style={{ display: 'flex' }}>
        <NavBar setDrawerOpen={setDrawerOpen} />
        <div style={{ minWidth: 0, flex: 1, width: '100%', minHeight: '100vh', flexDirection: 'column', display: 'flex' }} >
          <Toolbar />
          <div style={{ flex: 1 }}>
            <Outlet />
          </div>
          <Footer />
        </div>
      </div>
    </>
  );

};

export default Layout;